import React,{useState} from 'react'
import './menuMobile.scss'
import scrollTo from 'gatsby-plugin-smoothscroll';
import { Link } from 'gatsby';

const MenuMobile = () => {

    const [openMenu, setOpenMenu] = useState(false);

    const handleEvent = (id)=>{
      setOpenMenu(false);
      scrollTo(id);
    }
    
    return (
        <div className="menu-mobile">
            <div className="btn-menu">
              <button type="button" tabIndex="0" onClick={()=>setOpenMenu(!openMenu)}><span className="material-icons">{openMenu?'close':'menu'}</span></button>
            </div>
     
              <div className={`nav-options ${openMenu?'open':''}`}>
                <ul className="nav-menu-options">
                  <li className="nav-link">
                    <Link to='/' className="nav-link" onClick={() => setOpenMenu(false)} >Home</Link> 
                  </li>
                  <li className="nav-link">
                    <a role="button" tabIndex="-1" onClick={() => handleEvent('#technologies')}>Technologies</a>  
                  </li>
                  <li className="nav-link">
                    <a role="button" tabIndex="-1" onClick={() => handleEvent('#projects')} >Projects</a>  
                  </li>  
                  <li className="nav-link">
                    <a role="button" tabIndex="-1"  onClick={() => handleEvent('#contact')} >Contact</a>
                  </li>
                </ul>
              </div>
              <div className={`place-out `} role="button" onClick={()=>setOpenMenu(false)}>
            </div> 
              
        </div>
    )
}

export default MenuMobile
